"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by inf011 on 15/08/2016.
 */

var mobx_1 = require("mobx");

var Api_1 = require("./Api");

var OrgaAPI_1 = require("../../api/OrgaAPI");

var ajt_storage_1 = require("ajt-storage");

var Cookies = require("js-cookie");

var SessState =
/** @class */
function () {
  function SessState(appState) {
    var _this = this;

    this.recurs = {
      RECCOD: '',
      RECDESC: '',
      ENTORNCOD: '',
      ENTORNDESC: '',
      RECURLHELP: ''
    };
    this.permis = -1;
    this.sessioId = null;
    this.loginInfo = {
      user: '',
      password: ''
    };
    this.carregantSessio = true;
    this.debug = Number(Cookies.get('ajt_debug')) === 1;
    this.appState = appState;
    this.sessApi = new Api_1.default(appState);
    this.orgaApi = new OrgaAPI_1.default(appState);
    this.bd = appState.config.bd;
    this.storage = new ajt_storage_1.default(ajt_storage_1.getStorage(ajt_storage_1.eStorageType.session), process.env.REACT_APP_SESSION_DATA_ENCRYPT); // Carreguem sessio

    this.loadSessio().then(function () {
      return _this.sessioCarregada();
    });
  }

  SessState.prototype.sessioCarregada = function () {
    this.carregantSessio = false;
  };

  SessState.prototype.ompleDebug = function () {
    this.debug = Number(Cookies.get('ajt_debug')) === 1;
  };

  SessState.prototype.reset = function () {
    this.loginInfo.user = '';
    this.loginInfo.password = '';
    this.treballador = null;
    this.permis = -1;
    this.sessioId = null;
    this.storage.remove('sessioId');
    this.storage.remove('loginInfo');
    this.storage.remove('treballador');
    this.storage.remove('permis');
    this.init();
  };

  SessState.prototype.setRecurs = function (pRecCod) {
    this.appState.config.recCod = pRecCod;
    this.recurs = {
      RECCOD: pRecCod,
      RECDESC: '',
      ENTORNCOD: '',
      ENTORNDESC: '',
      RECURLHELP: ''
    };
    this.getDadesRecurs(pRecCod).then();
  };

  SessState.prototype.setUsuari = function (usuari) {
    this.loginInfo.user = usuari.toUpperCase();
  };

  SessState.prototype.setPassword = function (password) {
    this.loginInfo.password = password;
  };

  Object.defineProperty(SessState.prototype, "sessioIdObject", {
    get: function get() {
      return {
        sessioId: this.sessioId
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "esLoginat", {
    get: function get() {
      return this.sessioId !== null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "tePermis", {
    get: function get() {
      return !this.appState.config.recCod || this.permis > 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "treballadorKey", {
    get: function get() {
      if (!this.treballador) {
        return null;
      }

      return this.treballador.key;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "idEmpresa", {
    get: function get() {
      return this.treballadorKey ? this.treballadorKey.idEmpresa : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "idTreballador", {
    get: function get() {
      return this.treballadorKey ? this.treballadorKey.idTreballador : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "loginUser", {
    get: function get() {
      return this.loginInfo ? this.loginInfo.user : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "llocDesc", {
    get: function get() {
      return this.treballador ? this.treballador.llocDesc : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "persCod", {
    get: function get() {
      return this.treballador ? this.treballador.persCod : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "esCap", {
    get: function get() {
      return this.treballador && !!this.treballador.capNivOrg;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "nivell", {
    get: function get() {
      return this.treballador ? this.treballador.nivell : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "cami", {
    get: function get() {
      return this.treballador && this.treballador.nivell ? this.treballador.nivell.split('>') : [];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SessState.prototype, "potFerMenteniment", {
    get: function get() {
      return this.treballador && this.treballador.nivell ? this.treballador.nivell.startsWith('00001>00008>') : false;
    },
    enumerable: true,
    configurable: true
  });

  SessState.prototype.init = function () {
    this.ompleDebug();
    this.preLoginInfo();
  };

  SessState.prototype.getClientInfo = function () {
    var _this = this;

    if (!this.IP) {
      return this.sessApi.getClientInfo().then(mobx_1.action(function (response) {
        var tResponse = response;

        if (!tResponse) {
          return;
        }

        _this.IP = tResponse.IP;
        _this.HOST = tResponse.HOST.toUpperCase();
        _this.BROWSER = tResponse.BROWSER;
      }));
    } else {
      return Promise.resolve();
    }
  };

  SessState.prototype.preLoginInfo = function () {
    var _this = this;

    this.getClientInfo().then(function () {
      if (_this.HOST === 'PC1294.AJMANRESA.LOC') {
        _this.loginInfo = {
          user: 'MTRULLAS',
          password: _this.bd === 'PRO' ? 'KANU7' : 'BEZO9'
        };
      } else if (_this.HOST === 'PC994.AJMANRESA.LOC' || _this.HOST === 'PC1645.AJMANRESA.LOC') {
        _this.loginInfo = {
          user: 'JRIU',
          password: 'JORDI'
        };
      } else if (_this.HOST === 'PC1003.AJMANRESA.LOC') {
        _this.loginInfo = {
          user: 'XNAVAL',
          password: 'XEVIN'
        };
      } else if (_this.HOST === 'PC1002.AJMANRESA.LOC') {
        _this.loginInfo = {
          user: 'XFORRADELLAS',
          password: 'CHFYW'
        };
      } else if (_this.HOST === 'PC1559.AJMANRESA.LOC') {
        _this.loginInfo = {
          user: 'JMPACHECO',
          password: 'LIA09'
        };
      }
    });
  };

  SessState.prototype.loadSessio = function () {
    var _this = this; // Mirar si tenim la sessio al storage


    if (this.storage.get('sessioId')) {
      this.sessioId = this.storage.get('sessioId');
      this.treballador = this.storage.get('treballador');
      this.loginInfo = this.storage.get('loginInfo');
      this.permis = Number(this.storage.get('permis'));
    } else {
      // Mirar si tenim cookie de sessio de l'extranet
      var ususariExtranet_1 = Cookies.get('ExtranetWEBCAR_Usuari');
      var sessioExtranet_1 = Cookies.get('ExtranetWEBCAR_Sessio');

      if (!!ususariExtranet_1 && !!sessioExtranet_1) {
        return this.getDadesRecurs(this.appState.config.recCod).then(function () {
          _this.setUsuari(ususariExtranet_1);

          return _this.login(ususariExtranet_1, sessioExtranet_1);
        });
      }
    }

    return this.getDadesRecurs(this.appState.config.recCod);
  };

  SessState.prototype.loginBySescod = function (sescod) {
    var _this = this;

    return this.sessApi.getSessio(sescod).then(mobx_1.action(function (response) {
      if (!response) {
        _this.reset();

        return;
      }

      _this.sessioId = response.sescod;
      _this.loginInfo.user = response.login;
      _this.loginInfo.password = '';
      _this.treballador = {
        key: {
          idEmpresa: response.idEmpresa,
          idTreballador: response.idTreballador
        },
        nomiCognoms: response.nom
      };

      _this.storage.set('sessioId', _this.sessioId);

      _this.storage.set('loginInfo', _this.loginInfo);

      _this.storage.set('treballador', _this.treballador);
    })).then(function () {
      return Promise.all([_this.getPermis(), _this.getDadesTreballador()]);
    });
  };

  SessState.prototype.login = function (usuari, password) {
    var _this = this;

    return this.sessApi.postLogin(usuari, password).then(mobx_1.action(function (response) {
      if (!response) {
        _this.reset();

        return;
      }

      _this.sessioId = response.sescod;
      _this.loginInfo.password = '';
      _this.treballador = {
        key: {
          idEmpresa: response.idEmpresa,
          idTreballador: response.idTreballador
        },
        nomiCognoms: response.nom
      };

      _this.storage.set('sessioId', _this.sessioId);

      _this.storage.set('loginInfo', _this.loginInfo);

      _this.storage.set('treballador', _this.treballador);
    })).then(function () {
      return Promise.all([_this.getPermis(), _this.getDadesTreballador()]);
    });
  };
  /**
   * Llegeix el nom del recurs i el nivell de permís de l'usuari
   */


  SessState.prototype.getDadesRecurs = function (pRecCod) {
    var _this = this;

    if (!pRecCod) {
      this.recurs = {
        RECCOD: '',
        RECDESC: '',
        ENTORNCOD: '',
        ENTORNDESC: '',
        RECURLHELP: ''
      };
      this.permis = -1;
      return Promise.resolve(true);
    }

    return this.sessApi.getRecurs(pRecCod).then(mobx_1.action(function (response) {
      if (response) {
        _this.recurs = __assign({
          RECCOD: pRecCod
        }, response);
      }

      return true;
    })).then(function () {
      return _this.getPermis();
    });
  };
  /**
   * Llegeix nivell de permís de l'usuari segons el recurs
   */


  SessState.prototype.getPermis = function () {
    var _this = this;

    if (!this.esLoginat || !this.loginUser || !this.recurs.RECCOD) {
      this.permis = -1;
      this.storage.remove('permis');
      return Promise.resolve(true);
    }

    return this.sessApi.postPermis(this.loginUser, this.recurs.RECCOD).then(mobx_1.action(function (response) {
      _this.permis = response || -1;

      _this.storage.set('permis', _this.permis.toString());

      return true;
    }));
  };
  /**
   * Llegeix les dades del treballador a partir de l'organigrma
   */


  SessState.prototype.getDadesTreballador = function () {
    var _this = this;

    if (!this.esLoginat || !this.loginUser) {
      return Promise.resolve(true);
    }

    return this.orgaApi.getDadesTreballador(this.idEmpresa, this.idTreballador).then(mobx_1.action(function (dadesTreb) {
      _this.treballador = Object.assign({
        carrec: dadesTreb.PCARREC,
        nivell: dadesTreb.NIVELL,
        capNivOrg: dadesTreb.CAPNIVORG,
        idLloc: dadesTreb.ID_LLOC,
        llocDesc: dadesTreb.LLOCDESC,
        persCod: dadesTreb.PERSCOD
      }, _this.treballador);

      _this.storage.set('treballador', _this.appState.sessState.treballador);

      return true;
    }));
  };

  SessState.prototype.changeTreballador = function (treballador) {
    this.treballador = treballador;
  };

  __decorate([mobx_1.observable], SessState.prototype, "recurs", void 0);

  __decorate([mobx_1.observable], SessState.prototype, "permis", void 0);

  __decorate([mobx_1.observable], SessState.prototype, "sessioId", void 0);

  __decorate([mobx_1.observable], SessState.prototype, "loginInfo", void 0);

  __decorate([mobx_1.observable], SessState.prototype, "treballador", void 0);

  __decorate([mobx_1.observable], SessState.prototype, "carregantSessio", void 0);

  __decorate([mobx_1.observable], SessState.prototype, "debug", void 0);

  __decorate([mobx_1.action], SessState.prototype, "sessioCarregada", null);

  __decorate([mobx_1.action], SessState.prototype, "ompleDebug", null);

  __decorate([mobx_1.action], SessState.prototype, "reset", null);

  __decorate([mobx_1.action], SessState.prototype, "setRecurs", null);

  __decorate([mobx_1.action], SessState.prototype, "setUsuari", null);

  __decorate([mobx_1.action], SessState.prototype, "setPassword", null);

  __decorate([mobx_1.computed], SessState.prototype, "sessioIdObject", null);

  __decorate([mobx_1.computed], SessState.prototype, "esLoginat", null);

  __decorate([mobx_1.computed], SessState.prototype, "tePermis", null);

  __decorate([mobx_1.computed], SessState.prototype, "treballadorKey", null);

  __decorate([mobx_1.computed], SessState.prototype, "idEmpresa", null);

  __decorate([mobx_1.computed], SessState.prototype, "idTreballador", null);

  __decorate([mobx_1.computed], SessState.prototype, "loginUser", null);

  __decorate([mobx_1.computed], SessState.prototype, "llocDesc", null);

  __decorate([mobx_1.computed], SessState.prototype, "persCod", null);

  __decorate([mobx_1.computed], SessState.prototype, "esCap", null);

  __decorate([mobx_1.computed], SessState.prototype, "nivell", null);

  __decorate([mobx_1.computed], SessState.prototype, "cami", null);

  __decorate([mobx_1.computed], SessState.prototype, "potFerMenteniment", null);

  __decorate([mobx_1.action], SessState.prototype, "init", null);

  __decorate([mobx_1.action], SessState.prototype, "getClientInfo", null);

  __decorate([mobx_1.action], SessState.prototype, "preLoginInfo", null);

  __decorate([mobx_1.action], SessState.prototype, "loadSessio", null);

  __decorate([mobx_1.action], SessState.prototype, "loginBySescod", null);

  __decorate([mobx_1.action], SessState.prototype, "login", null);

  __decorate([mobx_1.action], SessState.prototype, "changeTreballador", null);

  return SessState;
}();

exports.default = SessState;